import React, { useState, useEffect, useRef } from "react";

import AdminToolsDataService from "../../../services/admin-tools.service";
import { NotificationManager } from "react-notifications";
import { useTranslation } from "react-i18next";

import {
  Spin,
  Switch,
  Table,
  Tooltip,
  Input,
  Button,
  Space,
} from "antd";

import { SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";

const DiamondRapNetPermission = () => {
  const { t } = useTranslation();
  const [diamondRapNetPermissionData, setDiamondRapNetPermission] = useState(
    []
  );
  const [loading, setLoading] = useState(false);

  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [totalCount, setTotalCount] = useState(0);
  const [sortColumnName, setSortColumnName] = useState("dealerID");
  const [sortType, setSortType] = useState("ASC");
  const [search, setSearch] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef(null);

  useEffect(() => {
    GetDiamondImportRightsList(
      pageNo,
      pageSize,
      sortColumnName,
      sortType,
      search
    );
  }, []);

  const GetDiamondImportRightsList = (
    pageNo,
    pageSize,
    sortColumnName,
    sortOrder,
    filters
  ) => {
    let inputData = {
      pageNumber: pageNo,
      pageSize: pageSize,
      sortColumnName: sortColumnName || "dealerID",
      sortOrder: sortOrder || "ASC",
      lstColumnFilter: filters || [],
    };
    setLoading(true);
    AdminToolsDataService.GetDiamondImportRightsList(inputData)
      .then((response) => {
        setLoading(false);
        var message = response.data.message;
        var responseData = response.data.responseData.thirdPartyDiamond;
        var totalCount = response.data.responseData.totalRecord;
        if (message === "Success") {
          setDiamondRapNetPermission(responseData);
          setTotalCount(totalCount);
        } else {
          setDiamondRapNetPermission([]);
          setTotalCount(0);
        }
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
        setDiamondRapNetPermission([]);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleOnChange = (row, e) => {
    const temp = diamondRapNetPermissionData.map((x) => {
      if (x.dealerID === row.dealerID) {
        return { ...x, enabled: e };
      } else return x;
    });
    setDiamondRapNetPermission(temp);
    const item = temp.find((x) => x.dealerID === row.dealerID);
    handleSubmit(item);
  };

  const handleSubmit = (item) => {
    let inputData = {
      dealerID: Number(item.dealerID),
      enabled: item.enabled,
    };
    setLoading(true);
    AdminToolsDataService.SaveDiamondImportRights(inputData)
      .then((response) => {
        var message = response.data.message;
        if (message === "Success") {
          NotificationManager.success(t("Data Updated Successfully."));
          GetDiamondImportRightsList(
            pageNo,
            pageSize,
            sortColumnName,
            sortType,
            search
          );
        } else {
          NotificationManager.error(t("Data Not Updated."));
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  function handleSearch(selectedKeys, confirm, dataIndex) {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  }
  function handleReset(clearFilters, confirm) {
    clearFilters();
    setSearchText("");
    confirm();
    setSearch([]);
  }
  function getColumnSearchProps(dataIndex) {
    return {
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div
          style={{ padding: 8 }}
          onKeyDown={(e) => e.stopPropagation()}
        >
          <Input
            ref={searchInput}
            placeholder={t("Search")}
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(
                e.target.value ? [e.target.value] : []
              )
            }
            onPressEnter={() =>
              handleSearch(selectedKeys, confirm, dataIndex)
            }
            style={{
              width: 188,
              marginBottom: 8,
              display: "block",
            }}
          />

          <Space>
            <Button
              type="primary"
              onClick={() =>
                handleSearch(selectedKeys, confirm, dataIndex)
              }
              icon={<SearchOutlined />}
              size="small"
              style={{ width: 90,height:26 }}
            >
              {t("Search")}
            </Button>

            <Button
              onClick={() =>
                handleReset(clearFilters, confirm)
              }
              size="small"
              style={{ width: 90 }}
            >
              {t("Reset")}
            </Button>
          </Space>
        </div>
      ),

      filterIcon: (filtered) => (
        <SearchOutlined
          style={{
            color: filtered ? "#1890ff" : undefined,
          }}
        />
      ),

      onFilter: (value, record) =>
        record[dataIndex]
          ?.toString()
          .toLowerCase()
          .includes(value.toLowerCase()),

      render: (text) =>
        searchedColumn === dataIndex ? (
          <Highlighter
            highlightStyle={{
              backgroundColor: "#ffc069",
              padding: 0,
            }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ""}
          />
        ) : (
          text
        ),
    };
  }
  const handleTableChange = (
    pagination,
    filters,
    sorter
  ) => {
    var tableBody = document.querySelector(
      ".table__scroll .ant-table-body"
    );
    if (tableBody) {
      tableBody.scrollTop = 0;
    }
    let type = "ASC";
    let column = "dealerID";
    let filter = [];
    if (sorter.order === "descend") {
      type = "DESC";
      column = sorter.field;
    } else if (sorter.order === "ascend") {
      type = "ASC";
      column = sorter.field;
    }
    setSortType(type);
    setSortColumnName(column);
    if (filters.dealerID) {
      filter.push({
        columnName: "dealerID",
        columnValue: filters.dealerID[0],
        columnType: "Input",
      });
    }
    if (filters.dealerName) {
      filter.push({
        columnName: "dealerName",
        columnValue: filters.dealerName[0],
        columnType: "Input",
      });
    }

    if (filters.dealerCompany) {
      filter.push({
        columnName: "dealerCompany",
        columnValue: filters.dealerCompany[0],
        columnType: "Input",
      });
    }
    setSearch(filter);
    setPageNo(pagination.current);
    setPageSize(pagination.pageSize);
    GetDiamondImportRightsList(
      pagination.current,
      pagination.pageSize,
      column,
      type,
      filter
    );
  };

  return (
    <React.Fragment>
      <div className="diamond_section">
        <div className="form__fields">
          <div className="row">
            <div className="col-md-12">
              <h4 className="workarea__heading mt-0 mb-0">
                {t("Enable 3rd Party Diamond Imports")}
              </h4>
            </div>
            <div className="col-md-12 mt-4">
              <div className="dealer_tbldiv table__scroll">
                <Spin spinning={loading} size="large">
                  <Table
                    scroll={{ y: "calc(100vh - 340px)" }}
                    dataSource={diamondRapNetPermissionData}
                    onChange={handleTableChange}
                    pagination={{
                      size: "small",
                      total: totalCount,
                      current: pageNo,
                      pageSize: pageSize,
                      pageSizeOptions: [10, 15, 20, 50, 100],
                      responsive: true,
                      showSizeChanger: true,
                    }}
                    columns={[
                      {
                        title: (
                          <Tooltip title={t("Dealer ID")}>
                            {t("Dealer ID")}
                          </Tooltip>
                        ),

                        dataIndex: "dealerID",
                        key: "dealerID",

                        ellipsis: true,

                        ...getColumnSearchProps("dealerID"),

                        sorter: (a, b) => {},

                        showSorterTooltip: false,
                      },

                      {
                        title: (
                          <Tooltip title={t("Dealer Name")}>
                            {t("Dealer Name")}
                          </Tooltip>
                        ),

                        dataIndex: "dealerName",

                        ellipsis: true,
                        showSorterTooltip: false,
                      },
                      {
                        title: (
                          <Tooltip title={t("Dealer Company")}>
                            {t("Dealer Company")}
                          </Tooltip>
                        ),
                        dataIndex: "dealerCompany",
                        key: "dealerCompany",

                        ellipsis: true,
                        ...getColumnSearchProps(
                          "dealerCompany"
                        ),
                        sorter: (a, b) => {},
                        showSorterTooltip: false,
                      },
                      {
                        title: (
                          <Tooltip title={t("Enabled")}>{t("Enabled")}</Tooltip>
                        ),
                        dataIndex: "enabled",
                        key: "enabled",
                        ellipsis: true,
                        render: (item, row) => {
                          return (
                            <Switch
                              checkedChildren={t("Yes")}
                              unCheckedChildren={t("No")}
                              checked={row.enabled}
                              onChange={(e) =>
                                handleOnChange(row, e)
                              }
                            />
                          );
                        },
                      },
                    ]}
                  />
                </Spin>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default DiamondRapNetPermission;
